import React from 'react'
import { Address } from '../../models'
import { Box, MenuItem, Select } from '@mui/material'

interface ShippingAddressProps {
  handleSelected: (address: string) => void
  selected: string | null
  availableAddresses: Address[]
}

const ShippingAddress: React.FC<ShippingAddressProps> = ({ selected, handleSelected, availableAddresses }) => {
  return (
    <Box>
      {selected !== null && availableAddresses !== null && (
        <Select
          fullWidth
          value={selected}
          onChange={e => {
            handleSelected(e.target.value)
          }}
        >
          {availableAddresses.map(address => (
            <MenuItem key={address.addressId} value={address.addressId}>
              {address.addressId}
            </MenuItem>
          ))}
        </Select>
      )}
    </Box>
  )
}

export default ShippingAddress
